import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ar", // Set Arabic as default fallback
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
    ns: ["common", "Navigation"],
    defaultNS: "common",
    react: {
      useSuspense: false,
    },
  });

// **Ensure default language is set properly**
const savedLanguage = localStorage.getItem("language") || "ar";
if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "ar");
  i18n.changeLanguage("ar"); // Set Arabic as the first-time default
}

// **Handle direction (RTL/LTR)**
i18n.on("languageChanged", (lng) => {
  const direction = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
  document.body.classList.remove("rtl", "ltr");
  document.body.classList.add(direction);
});

// Set initial direction on page load
const initialDirection = savedLanguage === "ar" ? "rtl" : "ltr";
document.documentElement.dir = initialDirection;
document.documentElement.lang = savedLanguage;
document.body.classList.add(initialDirection);

export default i18n;
